import React, { useEffect, useState } from 'react';
import axios from 'axios';
import MainLayout from './MainLayout';
import { useNavigate } from 'react-router-dom';

const ProjectDashboard = () => {
  const [projects, setProjects] = useState([]);
  const [error, setError] = useState('');
  const token = localStorage.getItem('token');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await axios.get('https://openmkm.vidyayug.com/api/projects/list', {
          headers: { Authorization: token }
        });
        setProjects(response.data.projects || []);
      } catch (err) {
        setError('Failed to fetch projects');
        console.error(err);
      }
    };

    fetchProjects();
  }, [token]);

  const handleReUpload = (project) => {
    localStorage.setItem('project_id', project.project_id);
    localStorage.setItem('project_name', project.name);
    localStorage.setItem('project_description', project.description);
    navigate('/upload');
  };

  const handleRunOpenMKM = (projectId) => {
    localStorage.setItem('project_id', projectId);
    navigate('/run-openmkm');
  };

  return (
    <MainLayout>
      <div style={styles.container}>
        <h2>Your Projects</h2>
        {error && <p style={{ color: 'red' }}>{error}</p>}

        {projects.length === 0 ? (
          <p>No projects found. Go to Upload Files to start one.</p>
        ) : (
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>Project Name</th>
                <th style={styles.th}>Description</th>
                <th style={styles.th}>Status</th>
                <th style={styles.th}>Created</th>
                <th style={styles.th}>Updated</th>
                <th style={styles.th}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {projects.map((proj) => (
                <tr key={proj.project_id}>
                  <td style={styles.td}>{proj.name}</td>
                  <td 
                    style={{
                    ...styles.td,
                    maxWidth: '200px',       // Limit cell width
                    whiteSpace: 'nowrap',    // Prevent line breaks
                    overflow: 'hidden',      // Hide overflow text
                    textOverflow: 'ellipsis' // Add "..."
                    }}
                    title={proj.description}   // Tooltip with full description
                    >
                    {proj.description}
                  </td>
                  <td style={styles.td}>
                    <span style={{ ...styles.status, ...styles[proj.status.toLowerCase()] }}>
                      {proj.status}
                    </span>
                  </td>
                  <td style={styles.td}>{proj.created_at}</td>
                  <td style={styles.td}>{proj.updated_at}</td>
                  <td style={{ ...styles.td, ...styles.actionsCell }}>
                    <button style={styles.btn} onClick={() => handleReUpload(proj)}>
                        Re-Upload
                    </button>
                    <button style={styles.runBtn} onClick={() => handleRunOpenMKM(proj.project_id)}>
                        Re-Run
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </MainLayout>
  );
};

const styles = {
  container: {
    padding: '20px',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '20px',
    background: '#fff',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
  },
  th: {
    textAlign: 'left',
    borderBottom: '2px solid #ccc',
    padding: '10px',
    background: '#f9f9f9',
  },
  td: {
    padding: '10px',
    borderBottom: '1px solid #eee',
  },
  btn: {
    marginRight: '8px',
    padding: '6px 12px',
    backgroundColor: '#3498db',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
  },
  runBtn: {
    padding: '6px 12px',
    backgroundColor: '#27ae60',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    flex: '0 0 auto',
  },
  status: {
    padding: '4px 8px',
    borderRadius: '4px',
    fontWeight: 'bold',
    fontSize: '13px',
  },
  pending: {
    backgroundColor: '#f39c12',
    color: '#fff',
  },
  running: {
    backgroundColor: '#2980b9',
    color: '#fff',
  },
  completed: {
    backgroundColor: '#2ecc71',
    color: '#fff',
  },
  failed: {
    backgroundColor: '#e74c3c',
    color: '#fff',
  },
};

export default ProjectDashboard;
